<template>
  <section id="product" class="pb-8">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10"> </v-col>
      </v-row>
    </v-container>
    <div class="svg-border-rounded text-light">
      <v-col  class="text-center">
              <h2 class="font-weight-light:999 display-1">公司产品</h2>
              <h1 class="font-weight-light:999  display-1 custom-text-color" >Products</h1>
            </v-col>
      <ProductList></ProductList>
      
    </div>
  </section>
</template>



<style lang="scss">
$main_color: #283e79;

ul {
  font-size: 13px;
  line-height: 1.5em;
  margin: 5px 0 15px;
  padding: 0;

  li {
    list-style: none;
    position: relative;
    padding: 0 0 0 20px;
  }

  li {
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 5px;
      width: 10px;
      height: 10px;
      background-color: $main_color;
      border-radius: 50%;
      -moz-border-radius: 50%;
      -webkit-eeborder-radius: 50%;
    }
  }
}
</style>

<style scoped>
.text-center{
  padding-top: 50px;
}
.header {
  background-color: #283e79;
  color: white;
}

.circle1 {
  border-radius: 50%;
  width: 400px;
  height: 500px;
  background-color: #f0f8ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle2 {
  border-radius: 50%;
  width: 371px;
  height: 500px;
  background-color: #e0effc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.svg-border-rounded svg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  color: #f4f7f5;
  z-index: -1;
}

#product {
  z-index: 0;
}

.content {
  z-index: 1;
}

svg {
  overflow: hidden;
}

section {
  position: relative;
}
</style>

<script>
import  ProductList   from './ProductList.vue'
export default {
 name: "introduce",
  components: {
    ProductList
  },

  computed: {
    size() {
      const size = { md: "large", xl: "x-large" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
  },
};
</script>